import React from "react";

const DanhSachThuocTinhTableRows = ({
  list,
  RoleSua,
  RoleXoa,
  btnSuaClick,
  btnKhoaClick,
  btnXoaClick,
}) => {
  return list.map((item, index) => {
    const daKhoa = item.IsActive === 0;
    // Thuộc tính đã phát sinh giao dịch thì không cho sửa, xóa
    const daPhatSinh = !!item.DaPhatSinhGiaoDich;
    return (
      <div
        className="custom-table-row"
        key={"item" + item.Id}
        style={{ minHeight: "62px" }}
      >
        <div className="custom-table-cell flex-basis-10 flex-basis-10-sm disk-mobile">
          <span className="mobile-column-name color7-bold">STT</span>
          <div className="center-wrapper">
            <p className="text-center color7">{index + 1}</p>
          </div>
        </div>
        <div className="custom-table-cell flex-basis-50 flex-basis-50-sm">
          <span className="mobile-column-name color7-bold">Tên</span>
          <div
            className="center-wrapper color7 word-break text-center"
            style={{ width: "100%", justifyContent: "center" }}
            title={item.Ten}
          >
            {item.Ten}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span className="mobile-column-name color7-bold">Trạng thái</span>
          <div
            className="center-wrapper text-center"
            style={{
              justifyContent: "flex-start",
              padding: "6px",
              borderRadius: "5px",
              textAlign: "center",
              color: daKhoa ? "#FF5C00" : "#00B699",
            }}
          >
            {daKhoa ? "Khóa" : "Đang dùng"}
          </div>
        </div>
        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span className="mobile-column-name color7-bold">Chức năng</span>
          <div
            className="center-wrapper"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {RoleSua && !daPhatSinh && (
              <a title="Sửa" onClick={() => btnSuaClick(item)}>
                <img src="/app-assets/images/icon-edit-v2.png" alt="Sửa" />
              </a>
            )}
            {RoleSua && !daKhoa && (
              <a title="Khóa" onClick={() => btnKhoaClick(item)}>
                <img
                  src="/app-assets/images/icon-mo-cau-hinh-tai-san.png"
                  alt="Khóa"
                />
              </a>
            )}
            {RoleSua && daKhoa && (
              <a title="Mở khóa" onClick={() => btnKhoaClick(item)}>
                <img
                  src="/app-assets/images/icon-khoa-cau-hinh-tai-san.png"
                  alt="Mở khóa"
                />
              </a>
            )}
            {RoleXoa && !daPhatSinh && (
              <a title="Xóa" onClick={() => btnXoaClick(item)}>
                <img src="/app-assets/images/icon-xoa-v2.png" alt="Xóa" />
              </a>
            )}
          </div>
        </div>
      </div>
    );
  });
};

const DanhSachThuocTinhTable = ({
  list,
  nhanCot,
  RoleSua,
  RoleXoa,
  btnSuaClick,
  btnKhoaClick,
  btnXoaClick,
}) => {
  if (!list || list.length === 0) {
    return (
      <div className="custom-table-row">
        <div
          className="custom-table-cell-v2 text-center red"
          style={{ width: "100%" }}
        >
          Không có dữ liệu
        </div>
      </div>
    );
  }

  return (
    <div className="Left808x200 Table-main-new css-table-ds">
      <div className="table-mobile sticky-table-bh2 table-mobile-hover">
        <div className="custom-table-wrapper" style={{ overflowX: "auto" }}>
          <div className="table-headers">
            <div className="custom-table-header flex-basis-10 flex-basis-10-sm text-center">
              <p className="color-do-bold">
                STT
                <br />[{list.length}]
              </p>
            </div>
            <div className="custom-table-header flex-basis-50 flex-basis-50-sm text-center">
              <p>{nhanCot}</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm text-center">
              <p>Trạng thái</p>
            </div>
            <div className="custom-table-header flex-basis-15 flex-basis-15-sm text-center">
              <p>Chức năng</p>
            </div>
          </div>
          <div className="custom-table-body">
            <DanhSachThuocTinhTableRows
              list={list}
              RoleSua={RoleSua}
              RoleXoa={RoleXoa}
              btnSuaClick={btnSuaClick}
              btnKhoaClick={btnKhoaClick}
              btnXoaClick={btnXoaClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DanhSachThuocTinhTable;
